// TODO: このファイルは削除しないでください。globalStateが必要ない場合でも、空のinterfaceと空のcustomStateをexportしてください

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ICustomGlobalState {
}

export const customState: ICustomGlobalState = {
};

